<section class="social-proof-section py-5">
  <div class="container">
    <div class="row text-center section-header-row">
      <div class="col-12">
        <h2 class="section-title">Proof from real member organizations</h2>
        <p class="section-subtitle">A few of the member organizations already using MemberTrace for real operational work.</p>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-4" *ngFor="let proof of proofSnippets">
        <a
          [routerLink]="proof.route"
          class="proof-card-anchor"
          [attr.aria-label]="'View use case: ' + proof.organization">
          <mat-card class="proof-card h-100">
            <mat-card-content class="p-4">
              <div class="proof-logo-wrap mb-3">
                <img [src]="proof.logo" [alt]="proof.organization" class="proof-logo" />
              </div>
              <p class="proof-type">{{ proof.communityType }}</p>
              <h3 class="proof-organization">{{ proof.organization }}</h3>
              <p class="proof-outcome">{{ proof.outcome }}</p>
              <span class="proof-cta">View use case</span>
            </mat-card-content>
          </mat-card>
        </a>
      </div>
    </div>
  </div>
</section>
